export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "delivery": {
            "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrega"])},
            "delivery_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semana"])},
            "delivery_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de entrega"])},
            "order": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pedido"])},
            "started_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de inicio"])},
            "delivered_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de entrega"])},
            "delivery_employee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Distribuidor"])}
          }
        }
      }
    }
  })
}